import { z } from 'zod';
import { zodResolver } from '@hookform/resolvers/zod';
import { DocumentFields } from '@dealstack/shared/lib/generated';

export const updateDocumentLibraryValidation = z.object({
	[DocumentFields.CLASSIFIERS]: z.array(z.string()),
	[DocumentFields.DOCUMENT_TITLE]: z.string(),
	[DocumentFields.FILE_NAME]: z.string(),
	[DocumentFields.UPLOAD_DATE]: z.string(),
	[DocumentFields.ASSOCIATED_TRANSACTIONS]: z.string(),
	[DocumentFields.RELATED_PEOPLE]: z.string(),
});

export const updateDocumentLibraryResolver = zodResolver(updateDocumentLibraryValidation);
